import {EntityType} from '../../backend/enums/entity-type';
import {translations} from '../../i18n/translations';

/**
 * Array with the available entity types in the Backend.
 *
 * Note: The property 'translation' gives the translation path to be used with i18n.
 * Example: t(entityTypes[0].translation)
 * We don't return the translated value, because once set the values won't change.
 * Thus, if the user updates his language on the profile, the values given by this
 * array won't change and translate to the new language set by the user.
 */
export const entityTypes: Array<{translation: string; type: EntityType}> = [
  {
    translation: translations.entity_types[EntityType.DayCareCenter],
    type: EntityType.DayCareCenter,
  },
  {translation: translations.entity_types[EntityType.Family], type: EntityType.Family},
  {
    translation: translations.entity_types[EntityType.Generic],
    type: EntityType.Generic,
  },
  {
    translation: translations.entity_types[EntityType.HomeSupport],
    type: EntityType.HomeSupport,
  },
  {
    translation: translations.entity_types[EntityType.Institution],
    type: EntityType.Institution,
  },
  {
    translation: translations.entity_types[EntityType.InsuranceCompany],
    type: EntityType.InsuranceCompany,
  },
  {
    translation: translations.entity_types[EntityType.TechCompany],
    type: EntityType.TechCompany,
  },
];
